// Generated by Melange

import * as Buhta_cabinet__CredentialItemPreview from "../../../components/organisms/Admin/Credentials/CredentialItemPreview.js";
import * as Buhta_cabinet__CredentialList from "../../../components/organisms/Admin/Credentials/CredentialList.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function CredentialsPage(Props) {
  const match = React.useState(function () {
    
  });
  const setCurrentItemId = match[1];
  const currentItemId = match[0];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Buhta_cabinet__CredentialList.make, {
        onItemClick: (function (item) {
          Curry._1(setCurrentItemId, (function (param) {
            return item.id;
          }));
        })
      }),
      currentItemId !== undefined ? JsxRuntime.jsx(Buhta_cabinet__CredentialItemPreview.make, {
          id: currentItemId,
          onClose: (function (param) {
            Curry._1(setCurrentItemId, (function (param) {
              
            }));
          })
        }) : null
    ],
    className: "h-full flex flex-col relative"
  });
}

const make = CredentialsPage;

export {
  make,
}
/* Buhta_cabinet__CredentialItemPreview Not a pure module */
